var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      !_vm.openMultiple
        ? _c("verify-tree-grid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.view === "list",
                expression: "view==='list'"
              }
            ],
            ref: "verifyTreeGrid",
            attrs: { context: _vm.context },
            on: {
              look: _vm.lookHandle,
              edit: _vm.editHandle,
              add: _vm.addHandle,
              split: _vm.splitHandle,
              copy: _vm.copyHandle,
              refresh: _vm.refreshHandle
            }
          })
        : _vm._e(),
      _c("verify-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "verifyWorkspace",
        attrs: {
          "parent-context": _vm.context,
          "open-multiple": _vm.openMultiple
        },
        on: {
          add: _vm.addHandle,
          edit: _vm.editHandle,
          copy: _vm.copyHandle,
          back: _vm.backToList
        }
      }),
      _c("job-no-rule-selector", {
        ref: "jobNoRuleSelector",
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: function($event) {
            _vm.jobNoRule.action === "add" ? _vm.doAddJob : _vm.doCopyJob
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }